import { render, staticRenderFns } from "./AgentNew.vue?vue&type=template&id=14a5f907&"
import script from "./AgentNew.vue?vue&type=script&lang=js&"
export * from "./AgentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports